import { render, staticRenderFns } from "./DetailInsentif.vue?vue&type=template&id=0c754515&scoped=true"
import script from "./DetailInsentif.vue?vue&type=script&lang=js"
export * from "./DetailInsentif.vue?vue&type=script&lang=js"
import style0 from "./DetailInsentif.vue?vue&type=style&index=0&id=0c754515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c754515",
  null
  
)

export default component.exports